var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 52,
    viewBox: "0 0 26 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 13C5.811 13 0 18.811 0 26C0 33.189 5.811 39 13 39C20.189 39 26 33.189 26 26C26 18.811 20.189 13 13 13ZM18.59 31.59C18.083 32.097 17.264 32.097 16.757 31.59L13 27.833L9.243 31.59C8.736 32.097 7.917 32.097 7.41 31.59C6.903 31.083 6.903 30.264 7.41 29.757L11.167 26L7.41 22.243C6.903 21.736 6.903 20.917 7.41 20.41C7.917 19.903 8.736 19.903 9.243 20.41L13 24.167L16.757 20.41C17.264 19.903 18.083 19.903 18.59 20.41C19.097 20.917 19.097 21.736 18.59 22.243L14.833 26L18.59 29.757C19.084 30.251 19.084 31.083 18.59 31.59Z",
    fill: "#BE1E2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/CancelIcon.6aa4f2b9bfc44dc4ecb1cf269cfc2e51.svg";
export { ForwardRef as ReactComponent };